const DEVELOPMENT = {
  BASE_URL: 'https://5nxq11nqjb.execute-api.ap-south-1.amazonaws.com/api/v1/tpap/auth/',
};
const PRODUCTION = {
  BASE_URL: 'https://api.ippopay.com/api/v1/user/auth/',
};

export const CONFIG = process.env.REACT_APP_ENV === 'production' ? PRODUCTION : DEVELOPMENT;
